export default [
  {
    key: 'id',
    title: '投放位ID',
    width: 50
  },
  {
    key: 'mediaName',
    title: '媒体名称',
    width: 100
  },
  {
    key: 'advertPosiName',
    title: '投放位名称',
    width: 200
  },
  {
    key: 'advertPosiDesc',
    title: '投放位媒体接口编码',
    width: 200
  },
  {
    key: 'createTime',
    title: '创建时间',
    width: 120
  },
  {
    key: 'opName',
    title: '创建人',
    width: 80
  },
  {
    key: 'upOpName',
    title: '修改人',
    width: 80
  },
  {
    key: 'upTime',
    title: '修改时间',
    width: 120
  },
  {
    key: 'control',
    title: '操作',
    width: 60,
    fixed: 'right'
  }
]
